module.exports = __webpack_public_path__ + "img/bg-cant-find.ffb1de3b.webp";